var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["loyalty-short-form-intro.j2"] = require( "loyalty-short-form-intro.j2" );
dependencies["loyalty-general-errors.j2"] = require( "loyalty-general-errors.j2" );
dependencies["loyalty-required-instructions.j2"] = require( "loyalty-required-instructions.j2" );
dependencies["loyalty-birthday-fields.j2"] = require( "loyalty-birthday-fields.j2" );
dependencies["loyalty-email-opt-in.j2"] = require( "loyalty-email-opt-in.j2" );
dependencies["loyalty-submit.j2"] = require( "loyalty-submit.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["loyalty/templates/loyalty-short-form.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "\n";
env.getTemplate("loyalty-short-form-intro.j2", false, "loyalty/templates/loyalty-short-form.j2", null, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
t_1.render(context.getVariables(), frame, function(t_4,t_2) {
if(t_4) { cb(t_4); return; }
output += t_2
output += "\n<div class=\"o-row\">\n\n    <form novalidate data-form-type=\"shortForm\" data-parsley-validate action=\"#\" method=\"post\"\n        ";
if(runtime.contextOrFrameLookup(context, frame, "loyaltyModal")) {
output += "\n            class=\"c-form js-loyalty-form o-column o-extra-small--12 o-small--10 o-small--centered\"\n        ";
;
}
else {
output += "\n            class=\"c-form js-loyalty-form\"\n        ";
;
}
output += " data-qa-loyalty-shortform>\n\n        ";
env.getTemplate("loyalty-general-errors.j2", false, "loyalty/templates/loyalty-short-form.j2", null, function(t_7,t_5) {
if(t_7) { cb(t_7); return; }
t_5.render(context.getVariables(), frame, function(t_8,t_6) {
if(t_8) { cb(t_8); return; }
output += t_6
output += "\n\n        ";
env.getTemplate("loyalty-required-instructions.j2", false, "loyalty/templates/loyalty-short-form.j2", null, function(t_11,t_9) {
if(t_11) { cb(t_11); return; }
t_9.render(context.getVariables(), frame, function(t_12,t_10) {
if(t_12) { cb(t_12); return; }
output += t_10
output += "\n\n        ";
env.getTemplate("loyalty-birthday-fields.j2", false, "loyalty/templates/loyalty-short-form.j2", null, function(t_15,t_13) {
if(t_15) { cb(t_15); return; }
t_13.render(context.getVariables(), frame, function(t_16,t_14) {
if(t_16) { cb(t_16); return; }
output += t_14
output += "\n\n        ";
env.getTemplate("loyalty-email-opt-in.j2", false, "loyalty/templates/loyalty-short-form.j2", null, function(t_19,t_17) {
if(t_19) { cb(t_19); return; }
t_17.render(context.getVariables(), frame, function(t_20,t_18) {
if(t_20) { cb(t_20); return; }
output += t_18
output += "\n\n        ";
env.getTemplate("loyalty-submit.j2", false, "loyalty/templates/loyalty-short-form.j2", null, function(t_23,t_21) {
if(t_23) { cb(t_23); return; }
t_21.render(context.getVariables(), frame, function(t_24,t_22) {
if(t_24) { cb(t_24); return; }
output += t_22
output += "\n    </form>\n\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})})})})})})})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["loyalty/templates/loyalty-short-form.j2"] , dependencies)